import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import ChatList from './chat/ChatList';
import ChatView from './chat/ChatView';

function AdminPanel({ userId, onBackClick, setActiveComponent }) {
  const [chatId, setChatId] = useState(null);

  // Light background pattern matching ChatView
  const backgroundPattern = `
    <svg width="120" height="120" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="empty-chat-pattern-light" x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse">
          <circle cx="15" cy="15" r="2" fill="#B1336E" opacity="0.05"/>
          <circle cx="60" cy="35" r="1.5" fill="#E6B43C" opacity="0.04"/>
          <circle cx="95" cy="70" r="2.5" fill="#67A43C" opacity="0.04"/>
          <circle cx="35" cy="90" r="1.8" fill="#B1336E" opacity="0.05"/>
          <circle cx="80" cy="100" r="2.2" fill="#E6B43C" opacity="0.03"/>
          <circle cx="110" cy="45" r="1.6" fill="#67A43C" opacity="0.04"/>
        </pattern>
      </defs>
      <rect width="120" height="120" fill="url(#empty-chat-pattern-light)"/>
    </svg>
  `;

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-slate-50">
      {/* Left: Chat List */}
      <div className="w-full sm:w-96 flex-shrink-0 overflow-y-auto bg-white shadow-sm">
        <ChatList
          userId={userId}
          onSelect={setChatId}
          selectedChatId={chatId}
          setActiveComponent={setActiveComponent}
        />
      </div>

      {/* Right: Chat View */}
      <div className="hidden sm:flex flex-col flex-1 bg-white">
        {chatId ? (
          <ChatView 
            chatId={chatId}
            userId={userId}
            setActiveComponent={setActiveComponent}
          />
        ) : (
          <div 
            className="flex-1 flex flex-col items-center justify-center text-slate-500 font-montserrat relative bg-slate-50"
            style={{
              backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(backgroundPattern)}")`,
              backgroundSize: '120px 120px',
              backgroundRepeat: 'repeat'
            }}
          >
            <div className="relative z-10 text-center p-8">
              <div className="mb-6 flex justify-center">
                <div className="p-6 bg-gradient-to-br from-brand-primary/10 to-brand-gold/10 rounded-3xl shadow-lg border border-brand-primary/20">
                  <MessageCircle className="w-20 h-20 text-brand-primary" />
                </div>
              </div>
              
              <h2 className="text-2xl font-extrabold text-slate-900 mb-3 font-montserrat">
                Bienvenido al Chat
              </h2>
              
              <p className="text-slate-600 max-w-md mx-auto font-montserrat">
                Selecciona una conversación de la lista para comenzar a chatear con tus clientes
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Mobile: Show only active chat */}
      {chatId && (
        <div className="sm:hidden fixed inset-0 z-50 bg-white">
          <ChatView 
            chatId={chatId} 
            onBackClick={() => setChatId(null)} 
            userId={userId}
          />
        </div>
      )}
    </div>
  );
}

export default AdminPanel;